const prefix = "FILES::";

export const SET_LOADING = `${prefix}SET_LOADING`;
export const SET_LIST = `${prefix}SET_LIST`;
export const APPEND_LIST = `${prefix}APPEND_LIST`;